export default __webpack_public_path__ + "static/media/988.8f3105dc.gif";